jQuery( document ).ready( function( $ ) {
    $( '.project-slider' ).not('.slick-initialized').each( function () {
        let slidesToShow = $( this ).attr( 'data-slidestoshow' );
        console.log(slidesToShow);
        $(this).slick({
            infinite: false,
            dots: false,
            arrows: true,
            slidesToShow:4,
            prevArrow: '<button class="arrow arrow-back"><span class="fal fa-arrow-left"></span></button>',
            nextArrow: '<button class="arrow arrow-next"><span class="fal fa-arrow-right"></span></button>',
            autoplay: false,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 992,
                    settings:{
                        slidesToShow: 3
                    }

                },
                {
                    breakpoint: 768,
                    settings:{
                        slidesToShow: 2
                    }

                },
                {
                    breakpoint: 576,
                    settings:{
                        slidesToShow: 1
                    }

                }
            ]
        });
    });
});